/* assets/review.js */
(function () {

    function qs(sel, root) {
        return (root || document).querySelector(sel);
    }

    function qsa(sel, root) {
        return Array.from((root || document).querySelectorAll(sel));
    }

    function getSubmissionId() {
        var params = new URLSearchParams(window.location.search);
        return (params.get("submission_id") || "").trim();
    }

    document.addEventListener("DOMContentLoaded", function () {

        var wrapper = qs(".review-wrapper");
        if (!wrapper) return;

        var shopDomain = (wrapper.getAttribute("data-shop") || "").trim();

        var form = qs("#submitReviewForm", wrapper);
        var btn = qs("#submitBtn", wrapper);
        var starInput = qs("#star", wrapper);
        var stars = qsa(".star", wrapper);

        var successBox = qs("#reviewSuccess", wrapper);
        var errorBox = qs("#reviewError", wrapper);
        var formContainer = qs("#reviewFormContainer", wrapper);

        if (!form || !btn) return;

        function showError(msg) {
            if (!errorBox) return;
            errorBox.textContent = String(msg || "");
            errorBox.style.display = "block";
            if (successBox) successBox.style.display = "none";
        }

        function clearError() {
            if (!errorBox) return;
            errorBox.textContent = "";
            errorBox.style.display = "none";
        }

        var header = qs(".review-header-success", wrapper);

        if (header) {
            var delay = Number(header.getAttribute("data-autohide-ms") || 0);

            if (delay > 0) {
                setTimeout(function () {
                    header.style.transition = "opacity 0.4s ease";
                    header.style.opacity = "0";

                    setTimeout(function () {
                        header.style.display = "none";
                    }, 400);
                }, delay);
            }
        }

        stars.forEach(function (star) {
            star.addEventListener("click", function () {
                var val = Number(star.dataset.value || "0");
                starInput.value = String(val);

                stars.forEach(function (s) {
                    var v = Number(s.dataset.value || "0");
                    s.classList.toggle("selected", v <= val);
                });
                clearError();
            });
        });

        form.addEventListener("submit", async function (e) {
            e.preventDefault();

            var submission = getSubmissionId();
            if (!submission) {
                errorBox.textContent = "Missing submission id";
                errorBox.style.display = "block";
                return;
            }

            var star = Number(starInput.value || "0");
            var title = qs("#title", wrapper).value.trim();
            var description = qs("#description", wrapper).value.trim();

            clearError();

            if (!star) {
                showError("Please choose an overall rating (1–5 stars)");
                return;
            }
            if (!title) {
                showError("Please enter a review title");
                return;
            }
            if (!description) {
                showError("Please tell us what you think about your Char-Broil product.");
                return;
            }

            btn.disabled = true;
            btn.textContent = "Submitting...";

            var fd = new FormData();
            fd.append("shop_domain", shopDomain);
            fd.append("submission_id", submission);
            fd.append("star", String(star));
            fd.append("title", title);
            fd.append("description", description);


            photoInputs.forEach(function (input) {
                if (input.files && input.files[0]) {
                    var key = (input.getAttribute("name") || "").trim();
                    if (!key) return;
                    fd.append(key, input.files[0]);
                }
            });

            try {
                const res = await fetch("/apps/wss/wholesale-review", {
                    method: "POST",
                    body: fd
                });

                const data = await res.json();

                if (res.ok && data.success) {
                    formContainer.style.display = "none";
                    successBox.innerHTML = `
          <section class="main main-review">
            <div class="container text-center">
              <div class="row row form-fields-columns">
                <div class="form-field--full">
                  <div class="p-4 shadow-lg rounded bg-white">
                    <p class="lead">
                      Your product has been registered and its warranty is now active.
                    </p>

                    <div class="step-indicators text-center mt-4">
                      <span class="step active"></span>
                      <span class="step active"></span>
                      <span class="step active"></span>
                    </div>
                  </div>

                  <div class="mt-4">
                    <a href="https://www.charbroil.com/" class="button-primary">START SHOPPING</a>
                    |
                    <a href="https://www.charbroil.com/blogs/recipes" class="button-secondary">EXPLORE RECIPES</a>
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </section>
        `;
                    successBox.style.display = "block";
                } else {
                    errorBox.textContent = data.message || "Submission failed.";
                    errorBox.style.display = "block";
                }

            } catch (err) {
                errorBox.textContent = "Network error.";
                errorBox.style.display = "block";
            }

            btn.disabled = false;
            btn.textContent = "Submit Review";
        });

        var photoInputs = qsa(".review-photo-input", wrapper);

        photoInputs.forEach(function (input) {
            var slot = input.closest(".review-photo-slot");
            if (!slot) return;

            var preview = qs(".review-photo-preview", slot);
            var placeholder = qs(".review-photo-ui", slot);
            var removeBtn = qs(".review-photo-remove", slot);

            function clearSlot() {
                input.value = "";

                if (preview) {
                    preview.src = "";
                    preview.style.display = "none";
                }
                if (placeholder) {
                    placeholder.style.display = "";
                }

                slot.classList.remove("has-image");
            }

            if (removeBtn) {
                removeBtn.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    clearSlot();
                });
            }

            input.addEventListener("change", function () {
                var file = input.files && input.files[0];
                if (!file) return;

                if (!file.type || !file.type.startsWith("image/")) {
                    alert("Only images allowed");
                    clearSlot();
                    return;
                }

                var reader = new FileReader();
                reader.onload = function (e) {
                    if (preview) {
                        preview.src = e.target && e.target.result ? String(e.target.result) : "";
                        preview.style.display = "block";
                    }
                    if (placeholder) {
                        placeholder.style.display = "none";
                    }
                    slot.classList.add("has-image");
                };
                reader.readAsDataURL(file);
            });
        });
    });
})();